<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';
import { Backend } from '@/_axios';
import VuexTypes from '@/store/types/index';

export default {
  name: 'app',
  mounted() {
    this.DEPOSIT_TYPES_LIST();  
  },
  methods: {
    ...mapActions('DepositTypes', [VuexTypes.depositTypes.DEPOSIT_TYPES_LIST]),
    setAuthToken(token) {
      if (token && token.length > 0) {
        Backend.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    },
  },
};

</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/css/style.css';
</style>
